import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { CardBody } from "../../../_metronic/_partials/controls";
import FiltersCard from "../filters/Filter";
import Table, { buttonsStyle } from "../tables/table";

function getData(products) {
  let data = [];
  for (let i = 0; i < products.length; ++i) {
    const elem = {};
    const product = products[i];

    elem.referencia = product?.referencia;
    elem.descripcion = product?.descripcion;
    elem.marca = product?.marca?.nombre;
    elem.familia = product?.familia?.descripcion;
    elem.tipoProducto = product?.tipo_producto?.descripcion;
    elem.precio = product?.precio + " €";
    elem.id = product?.id;

    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {
  familias: [],
  tipoProductos: [],
  marcas: [],
};

const ProductTableDialog = (props) => {
  const {
    title,
    open,
    setOpen,
    data,
    productMarcas,
    productFamilies,
    productTypes,
    onSelect,
  } = props;

  const [filteredData, setFilteredData] = useState(data);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  useEffect(() => {
    setFilteredData(data);
  }, [open]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.familias && filterOptions.familias.length > 0)
          filter =
            filter &&
            filterOptions.familias?.some((x) => x.id === item?.familia?.id);
        if (filterOptions.marcas && filterOptions.marcas.length > 0)
          filter =
            filter &&
            filterOptions.marcas?.some((x) => x.id === item?.marca?.id);
        if (
          filterOptions.tipoProductos &&
          filterOptions.tipoProductos.length > 0
        )
          filter =
            filter &&
            filterOptions.tipoProductos?.some(
              (x) => x.id === item?.tipo_producto?.id
            );
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setFilteredData(data);
  };

  const renderFiltersContent = () => {
    return (
      <>
        <Autocomplete
          className="w-100 mr-5"
          multiple
          id="autocomplete-marcas"
          filterSelectedOptions
          options={productMarcas}
          getOptionLabel={(option) => option?.nombre}
          value={filterOptions.marcas || []}
          onChange={(event, selected) => {
            setFilterOptions({
              ...filterOptions,
              marcas: selected,
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              label="Marcas"
            />
          )}
        />
        <div className="d-sm-flex w-100">
          <Autocomplete
            className="w-100 mr-5"
            multiple
            id="autocomplete-families"
            filterSelectedOptions
            options={productFamilies}
            getOptionLabel={(option) => option?.descripcion}
            value={filterOptions.familias || []}
            onChange={(event, selected) => {
              setFilterOptions({
                ...filterOptions,
                familias: selected,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Familia"
              />
            )}
          />
          <Autocomplete
            className="w-100 mr-5"
            multiple
            id="autocomplete-tipos"
            filterSelectedOptions
            options={productTypes}
            getOptionLabel={(option) => option?.descripcion}
            value={filterOptions.tipoProductos || []}
            onChange={(event, selected) => {
              setFilterOptions({
                ...filterOptions,
                tipoProductos: selected,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Tipo de Producto"
              />
            )}
          />
        </div>
      </>
    );
  };

  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Seleccionar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={(e) => {
              onSelect(cell);
              setOpen(false);
            }}
          >
            <AddCircle />
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    { dataField: "referencia", text: "Referencia", sort: true },
    {
      dataField: "descripcion",
      text: "Descripción",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "marca",
      text: "Marcas",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "familia",
      text: "Família",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "tipoProducto",
      text: "Tipo",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "precio",
      text: "Precio",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
    },
  ];

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="xl"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="table-dialog"
        className="backdrop"
      >
        <DialogTitle id="table-dialog">{title}</DialogTitle>
        <DialogContent>
          <FiltersCard
            className="px-0 mx-0"
            cardShadow={false}
            collapsable={false}
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
            handleSearch={handleSearch}
          />
          <CardBody className="pt-0 px-0">
            {!filteredData || !filteredData.length ? (
              <p>{"No hay productos disponibles."}</p>
            ) : (
              <Table data={getData(filteredData)} columns={columns} />
            )}
          </CardBody>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            variant="outlined"
          >
            Cancelar
          </Button>
          <br />
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ProductTableDialog;
